import { useContext, useState } from "react";
import {
  Grid,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from "@mui/material";
import { BCPMoon, BCPSun } from "../../../../components/icons/bcp/BCPIcons";
import { ColorModeContext } from "../../../../global/ColorModeContext";
import DateTimePickerComponent from "../../../../components/utilities/DateTimePickerComponent";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/en-gb";
import "moment/locale/zh-cn";
import "moment/locale/es-mx";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../../components/layout/cookies/CookieFunctions";

const locales = ["en-us", "en-gb", "es-mx", "zh-cn", "de"];

export default function DisplayTab() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const [locale, setLocale] = useState(getLocalStorage("locale") || "en-us");

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ mb: 1 }}>
            Date / Time Format
          </Grid>
          <Grid item xs={12} md={6}>
            <ToggleButtonGroup
              value={locale}
              exclusive
              fullWidth
              onChange={(event, newLocale) => {
                if (newLocale != null) {
                  setLocale(newLocale);
                  setLocalStorage("locale", newLocale);
                }
              }}
            >
              {locales.map((localeItem) => (
                <ToggleButton key={localeItem} value={localeItem}>
                  {localeItem}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              mt: { xs: -1, md: -2 },
            }}
          >
            <DateTimePickerComponent label={moment().format("LLLL")} disabled />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ mt: 1 }}>
        {theme?.palette?.mode === "dark" ? "Dark" : "Light"} Mode
        <IconButton
          sx={{ ml: 1 }}
          onClick={colorMode.toggleColorMode}
          color="inherit"
        >
          {theme?.palette?.mode === "dark" ? <BCPMoon /> : <BCPSun />}
        </IconButton>
      </Grid>
    </Grid>
  );
}
